// Resolve a calendar date at midnight in Madrid, including DST transitions.
export const madridMidnight = (date, nextDay = false) => {
  const [year, month, day] = date.split('-').map(Number);
  const wallTime = Date.UTC(year, month - 1, day + (nextDay ? 1 : 0));
  let instant = wallTime;
  const formatter = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  for (let i = 0; i < 3; i += 1) {
    const parts = Object.fromEntries(formatter.formatToParts(new Date(instant)).filter((part) => part.type !== 'literal').map((part) => [part.type, Number(part.value)]));
    const displayed = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
    instant = wallTime - (displayed - instant);
  }
  return new Date(instant).toISOString();
};
export const madridDateRange = (start, end) => ({
  start: start ? madridMidnight(start) : '',
  end: end ? new Date(new Date(madridMidnight(end, true)).getTime() - 1).toISOString() : ''
});
